module.exports = __webpack_public_path__ + "static/media/by.a487dded.webp";